function updateUrlWithCategory(categoryText) {
  if (!categoryText) return;
  // Get the category url name
  categoryText = getCategoryUrlName(categoryText);
  // Get the current url
  const currentUrl = window.location.href;
  // Check if the url already contains a hashtag
  if (currentUrl.indexOf("#") > -1) {
    // Remove the hashtag from the url
    const urlWithoutHashtag = currentUrl.split("#")[0];
    // Update the url with the new hashtag, replacing the entry in the history
    window.history.replaceState(
      null,
      null,
      `${urlWithoutHashtag}#${categoryText}`
    );
    return;
  }
  // Update the url with the new hashtag
  window.history.replaceState(null, null, `${currentUrl}#${categoryText}`);
}

function checkUrlForCategory(categories) {
  // Exit if the url does not contain a hashtag
  if (!window.location.hash) return;
  // Get the hashtag from the url
  const hashtag = window.location.hash;
  // Check if the hashtag matches a category
  const matchedCategory = checkHashtagCategoryMatch(hashtag, categories);
  return matchedCategory;
}

function checkHashtagCategoryMatch(hashtag, categories) {
  // Exit if there are no categories
  if (!categories.length) return;
  let matchedCategory = null;
  // Loop over the categories
  categories.forEach((category) => {
    // Get the category text content
    const categoryText = category.textContent;
    // Clean category text by replacing all spaces with dashe, making it lowercase and removing all special characters
    const categoryCleanName = getCategoryUrlName(categoryText);
    // Check if the hashtag matches the cleaned category name
    if (hashtag == `#${categoryCleanName}`) {
      // Update the matched category
      matchedCategory = category;
    }
  });
  // Return the matched category
  return matchedCategory;
}

/**
 * Get the category url name
 *
 * This function is used to convert a category name to a url name.
 * This takes care of converting special characters like ä, ö, ü and ß, as well as removing all special characters.
 *
 * @param {string} categoryName
 * @returns {string}
 */
function getCategoryUrlName(categoryName) {
  return categoryName
    .replace(/\s+/g, "-")
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export { checkUrlForCategory, updateUrlWithCategory };
